module.exports = __webpack_public_path__ + "static/media/brackets.f0049b43.svg";